export default __webpack_public_path__ + "static/media/9.c8eb4963.png";